/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "./translate";
import {
  setQryStrMedium,
  setQryStrSource,
} from "./redux/queryStrings/queryStringsActions";
import { RootTabsContainer } from "@afg-ikea/ikea-family-registration-module/dist";
import Constants from "./Constants";
import "./App.scss";

function App() {
  const dispatch = useDispatch();
  const i18n = useTranslate();
  const { getCurrentLanguage } = i18n;
  const [activeTab, setActiveTab] = useState(1);
  const mediumFromStore = useSelector(
    ({ queryStrings }) => queryStrings.medium
  );
  const sourceFromStore = useSelector(
    ({ queryStrings }) => queryStrings.source
  );
  const [lang, setLang] = useState("");
  useEffect(() => {
    document.addEventListener("contextmenu", (event) => event.preventDefault());
    const queryString = window.location.search;
    const parameters = new URLSearchParams(queryString);
    const medium = parameters.get("utm_medium") || parameters.get("utm_id");
    const source = parameters.get("utm_source");
    const url = window.location.href;
    if (url.search(Constants.verifyMemberSubPath) >= 0) {
      setActiveTab(2);
    } else if (url.search(Constants.updateProfileSubPath) >= 0) {
      setActiveTab(3);
    }
    dispatch(setQryStrMedium(medium));
    dispatch(setQryStrSource(source));
    setLang(parameters.get("lang"));
  }, []);

  const currLocale = lang
    ? lang
    : document.documentElement.lang
    ? document.documentElement.lang
    : getCurrentLanguage();

  return (
    <>
      {lang && lang === "ar-AE" ? (
        <div dir="rtl">
          <RootTabsContainer
            medium={mediumFromStore}
            source={sourceFromStore}
            locale={currLocale}
            initialTab={activeTab}
            mode="web"
          />
        </div>
      ) : (
        <RootTabsContainer
          medium={mediumFromStore}
          source={sourceFromStore}
          locale={currLocale}
          initialTab={activeTab}
          mode="web"
        />
      )}
    </>
  );
}

export default App;
